import { GlobalCostReportManager } from "src/modules/GlobalCostReportManager/GlobalCostReportManager";

export const GlobalCostReportPage: React.FC = () => {
  return <GlobalCostReportManager />;
};
